import {Routes} from '@angular/router';
import {LoginIndexComponent} from "./pages/login/login-index.component";
import {SessionService} from "./services/session.service";
import {AppointmentsService} from "./services/appointments.service";
import {AppointmentsComponent} from "./pages/appointments/appointments.component";
import {PatientComponent} from "./pages/patient/patient.component";
import {MainIndexComponent} from "./pages/main-index/main-index.component";
import {OverviewComponent} from "./pages/patient/tabs/overview/overview.component";
import {IdComponent} from "./pages/patient/tabs/id/id.component";
import {InfoComponent} from "./pages/patient/tabs/info/info.component";
import {PaymentComponent} from "./pages/patient/tabs/payment/payment.component";
import {DocsComponent} from "./pages/patient/tabs/docs/docs.component";
import {InsuranceComponent} from "./pages/patient/tabs/insurance/insurance.component";

export const routes:Routes = [
	{
		path: "login",
		title: "Login",
		component: LoginIndexComponent
	},
	{
		path: "appointments",
		canActivate: [SessionService.canActivateLoggedIn],
		component: MainIndexComponent,
		resolve: [AppointmentsService.resolveAppointments],
		children: [
			{
				path: "",
				title: "Appointments",
				component: AppointmentsComponent,
			},
			{
				path: ":id",
				title: "Appointment",
				component: PatientComponent,
				canActivate: [AppointmentsService.canActivateAppointment],
				children: [
					{
						path: "overview",
						title: "Overview",
						component: OverviewComponent
					},
					{
						path: "id",
						title: "ID",
						component: IdComponent
					},
					{
						path: "info",
						title: "Info",
						component: InfoComponent
					},
					{
						path: "insurance",
						title: "Insurance",
						component: InsuranceComponent
					},
					{
						path: "payment",
						title: "Payment",
						component: PaymentComponent
					},
					{
						path: "docs",
						title: "Docs",
						component: DocsComponent
					},
					{path: '**', redirectTo: 'overview'}
				]
			}
		]
	},
	{path: '**', redirectTo: 'appointments'}
];
